export interface AdditionalTargetsDataResponse {
  settings: {
    additionalTargets: string[];
  };
}

export interface AdditionalTargetsViewData {
  hasNoCompanySelected: boolean;
}

export const ADDITIONAL_TARGETS_LIMIT = 100;
